<script>
	import CappedString from './components/CappedString.svelte';
	import Reversed from './components/Reversed.svelte';
	import Calculator from './components/Calculator.svelte';
	import Caesar from './components/Caesar.svelte';
	import Analyze from './components/Analyze.svelte';
</script>

<main>
	<h1>Jest Svelte Testing</h1>
	<h3>String manipulation</h3>
	<CappedString />
	<Reversed />
	<Calculator />
	<Caesar />
	<Analyze />
</main>